export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  const row = [];
  for (let i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(Math.max(i - 3, 0), i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    const chuc = Math.floor(so / 10);
    const donvi = so % 10;
    if (chuc > 1) {
      chuoi = " " + chuSo[chuc] + " mươi";
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += " " + chuSo[donvi];
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    const tram = Math.floor(so / 100);
    const soDu = so % 100;
    if (daydu || tram > 0) {
      return ` ${chuSo[tram]} trăm${docHangChuc(soDu, true)}`;
    }
    return docHangChuc(soDu, false);
  };

  let ketQua = "";
  const viTri = row.length - 1;
  for (let i = viTri; i >= 0; i -= 1) {
    const soNhom = parseInt(row[i], 10);
    if (soNhom > 0) {
      ketQua += `${docKhoi(soNhom, i !== viTri)} ${tien[i]}`;
    }
  }

  const normalized = ketQua.trim();
  return `${normalized.charAt(0).toUpperCase() + normalized.slice(1)} đồng chẵn`;
};

const parseMoney = (value) => Number(String(value || "").replace(/\D/g, "")) || 0;
const fmt = (n) => new Intl.NumberFormat("vi-VN").format(parseMoney(n));
const formatMonth = (value) => String(value || "").replace(/\D/g, "").slice(0, 2).padStart(2, "0");

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row, i) => `
      <tr>
        <td class="text-center">${i + 1}</td>
        <td class="text-left">${row.fullName || ""}</td>
        <td class="text-center">${row.salaryLevel || ""}</td>
        <td class="text-right">${row.salaryCoefficient || ""}</td>
        <td class="text-right">${row.positionAllowanceCoefficient || ""}</td>
        <td class="text-right">${fmt(row.totalCoefficient)}</td>
        <td class="text-right">${fmt(row.monthlySalary)}</td>
        <td class="text-right">${fmt(row.dailySalary)}</td>
        <td class="text-right">${fmt(row.hourlySalary)}</td>
        <td class="text-right">${row.overtimeHoursWeekday || ""}</td>
        <td class="text-right">${fmt(row.overtimeAmountWeekday)}</td>
        <td class="text-right">${row.overtimeHoursWeekend || ""}</td>
        <td class="text-right">${fmt(row.overtimeAmountWeekend)}</td>
        <td class="text-right">${row.overtimeHoursHoliday || ""}</td>
        <td class="text-right">${fmt(row.overtimeAmountHoliday)}</td>
        <td class="text-right">${row.overtimeHoursNight || ""}</td>
        <td class="text-right">${fmt(row.overtimeAmountNight)}</td>
        <td class="text-right">${fmt(row.totalOvertimeAmount)}</td>
        <td class="text-right">${row.compensatoryLeaveHours || ""}</td>
        <td class="text-right">${fmt(row.compensatoryLeaveAmount)}</td>
        <td class="text-right">${fmt(row.actualPayment)}</td>
        <td class="text-center">${row.signature || ""}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Bảng Thanh Toán Tiền Làm Thêm Giờ</title>
      <style>
        @media print { @page { margin: 10mm; size: landscape; }
        }
        body { font-family: "Times New Roman", Times, serif; font-size: 12px; color: #000; padding: 20px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #000; padding: 3px; text-align: center; }
        .text-left { text-align: left; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .page-number {
          position: fixed;
          right: 8mm;
          bottom: 6mm;
          font-size: 11px;
        }
      </style>
    </head>
    <body>
      <div style="display:flex;justify-content:space-between">
        <div>
          <div><b>Đơn vị:</b> ${headerInfo.unit || ""}</div>
          <div><b>Bộ phận:</b> ${headerInfo.department || ""}</div>
        </div>
        <div style="text-align:center">
          <div><b>Mẫu số: 03 - LĐTL</b></div>
          <div><i>(TT 99/2025/TT-BTC)</i></div>
        </div>
      </div>
      <h2 style="text-align:center;margin:12px 0 6px">BẢNG THANH TOÁN TIỀN LÀM THÊM GIỜ</h2>
      <div style="text-align:center;margin-bottom:8px"><i>Tháng ${formatMonth(
        headerInfo.month
      )} năm ${headerInfo.year}</i></div>
      <div style="text-align:right;margin-bottom:8px">Số: ${headerInfo.docNumber || ""}</div>

      <table>
        <thead>
          <tr>
            <th rowspan="2">STT</th><th rowspan="2">Họ và tên</th><th rowspan="2">Ngạch bậc lương hoặc cấp bậc chức vụ</th>
            <th rowspan="2">Hệ số lương</th><th rowspan="2">Hệ số phụ cấp chức vụ</th><th rowspan="2">Cộng hệ số</th><th rowspan="2">Tiền lương tháng</th>
            <th colspan="2">Mức lương</th>
            <th colspan="2">Làm thêm ngày làm việc</th>
            <th colspan="2">Làm thêm T7,CN</th>
            <th colspan="2">Làm thêm lễ,tết</th>
            <th colspan="2">Làm thêm đêm</th>
            <th rowspan="2">Tổng cộng tiền</th><th colspan="2">Số ngày nghỉ bù</th><th rowspan="2">Số tiền thực được thanh toán</th><th rowspan="2">Người nhận tiền ký tên</th>
          </tr>
          <tr>
            <th>Ngày</th><th>Giờ</th>
            <th>Số giờ</th><th>Thành tiền</th>
            <th>Số giờ</th><th>Thành tiền</th><th>Số giờ</th><th>Thành tiền</th><th>Số giờ</th><th>Thành tiền</th>
            <th>Số giờ</th><th>Thành tiền</th>
          </tr>
          <tr style="background:#fafafa">
            <th>A</th><th>B</th><th>C</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th><th>13</th><th>14</th><th>15</th><th>16</th><th>17</th><th>18</th><th>D</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="10"><b>Cộng</b></td>
            <td><b>${fmt(totals.overtimeAmountWeekday)}</b></td>
            <td><b>${fmt(totals.overtimeHoursWeekend)}</b></td>
            <td><b>${fmt(totals.overtimeAmountWeekend)}</b></td>
            <td><b>${fmt(totals.overtimeHoursHoliday)}</b></td>
            <td><b>${fmt(totals.overtimeAmountHoliday)}</b></td>
            <td><b>${fmt(totals.overtimeHoursNight)}</b></td>
            <td><b>${fmt(totals.overtimeAmountNight)}</b></td>
            <td><b>${fmt(totals.totalOvertimeAmount)}</b></td>
            <td><b>${fmt(totals.compensatoryLeaveHours)}</b></td>
            <td><b>${fmt(totals.compensatoryLeaveAmount)}</b></td>
            <td><b>${fmt(totals.actualPayment)}</b></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top:10px"><i>Tổng số tiền (Viết bằng chữ): <b>${numberToWords(
        totals.actualPayment
      )}</b></i></div>
      <div style="display:flex;justify-content:space-between;margin-top:20px;text-align:center">
        <div><b>Người lập bảng</b><br/><i>(Ký, họ tên)</i></div>
        <div><b>Kế toán trưởng</b><br/><i>(Ký, họ tên)</i></div>
        <div><i>Ngày....tháng....năm....</i><br/><b>Người duyệt</b><br/><i>(Ký, họ tên)</i></div>
      </div>
      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
